var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndrawTheVoidI26B(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 650.864,
    height: 800,
    viewBox: "0 0 650.864 800",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-414.25 -77.75)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 280.614,
    cy: 49.574,
    rx: 280.614,
    ry: 49.574,
    transform: "translate(414.25 778.603)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(517.168 77.75)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 274,
    cy: 274.5,
    rx: 274,
    ry: 274.5,
    transform: "translate(-0.055)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226.399,
    cy: 226.399,
    r: 226.399,
    transform: "translate(47.715 47.848)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 185.554,
    cy: 185.554,
    r: 185.554,
    transform: "translate(88.56 88.693)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 133.039,
    cy: 133.039,
    r: 133.039,
    transform: "translate(141.075 141.208)",
    opacity: 0.05
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(575.081 274.212)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.8,515.588s-1.6,15.173-2.4,15.971.8,2.4,0,4.791-1.6,5.59,0,6.389-19.081,103.468-20.763,210.821c0,0,24.756,1.6,24.756-7.187,0,0,30.175-94.48,30.175-95.279s12.149-71.622,12.149-71.622L465.5,614.61l9.583,50.31S503.624,795.2,503.624,793.6s30.558-15.288,29.759-22.475-16.77-107.806-16.77-107.806l3.993-149.332Z",
    transform: "translate(-379.11 -231.78)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.192,772.026S368.63,814.35,383,815.947s19.964,1.6,26.353-4.791c3.493-3.493,10.565-8.179,16.26-11.709a21.027,21.027,0,0,0,9.977-19.995c-.421-3.907-1.881-7.126-5.475-7.426-9.583-.8-20.763-9.583-20.763-9.583Z",
    transform: "translate(-378.063 -254.238)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521,806.265s-21.561,42.324-7.187,43.921,19.964,1.6,26.353-4.791c3.493-3.493,10.565-8.179,16.26-11.709a21.027,21.027,0,0,0,9.977-19.995c-.421-3.907-1.881-7.126-5.475-7.426-9.583-.8-20.763-9.583-20.763-9.583Z",
    transform: "translate(-389.888 -257.333)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.059,88.719c1.349,0,13.623-21.85,20.778-34.8a33.567,33.567,0,1,1,33.531,12.52C50.042,80.017,43.221,103.1,43.221,103.1S-1.858,88.719.059,88.719Z",
    transform: "translate(60.791 6.859)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.023,213.635l-.666-1.458C73.472,213.234,9.213,213.234,8,213.234c-1.6,0,3.994-14.372-.8-15.172S.011,112.616.011,112.616s.8-33.737,0-52.1S43.133.817,47.925.018C52-.661,87.214,18.273,97.7,23.974a30.846,30.846,0,0,1,3.332,1.2c7.186,3.2,12.778,102.217,12.778,102.217l15.97,92.636-21.562,5.588Z",
    transform: "translate(22.899 74.167)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.884,527.16s15.876,41.525,3.1,39.928-19.408-35.4-19.408-35.4Z",
    transform: "translate(-391.307 -232.971)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.518,234.28l.111-2.565,5.1,1.27a5.7,5.7,0,0,0-2.286-4.2l5.436-.3a58.649,58.649,0,0,0-39.226-24.242c-11.757-1.7-24.849.762-32.911,9.488-3.911,4.232-6.368,9.615-8.116,15.106-3.219,10.113-3.875,22.169,2.838,30.389,6.823,8.355,18.74,9.991,29.477,11.025,3.778.364,7.737.7,11.238-.763a27.034,27.034,0,0,0-1.5-11.858,7.9,7.9,0,0,1-.8-3.777c.477-3.194,4.738-4,7.939-3.567s7.049,1.092,9.152-1.359c1.449-1.688,1.363-4.147,1.555-6.363C515.045,236.526,526.464,235.545,526.518,234.28Z",
    transform: "translate(-384.772 -203.735)",
    fill: "#2f2e41"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 39.113,
    cy: 39.113,
    r: 39.113,
    transform: "translate(883.608 756.772)",
    fill: "#888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,82.437A27.891,27.891,0,0,1,12.935,58.879a20.127,20.127,0,0,1,7.8-32.246,14.281,14.281,0,1,1,14.345,0,20.127,20.127,0,0,1,7.8,32.246A27.914,27.914,0,1,1,0,82.437Z",
    transform: "translate(424.257 711.005)",
    fill: "#888"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawTheVoidI26B);
export default __webpack_public_path__ + "static/media/undraw_the-void_i26b.a6074bdef745d4c1a9499bd7576302f5.svg";
export { ForwardRef as ReactComponent };